/*
 * @Author: COCO
 * @Date: 2018-01-25 12:38:36
 * @Last Modified by: COCO
 * @Last Modified time: 2019-02-25 18:45:09
 *
 */
import { setInterval, clearInterval, setTimeout } from 'timers';
export default {
  callbackArr: [],
  resizeTimeout: '',
  resize: function (callback) {
    var self = this;
    if (typeof window.onresize === 'function') {
      typeof callback === 'function' ? self.callbackArr.push(callback) : '';
    } else {
      window.onresize = function () {
        clearTimeout(self.resizeTimeout);
        self.resizeTimeout = setTimeout(function () {
          self.callbackArr.forEach(function (value, index) {
            value();
          });
        }, 300);
      };
    }
  },
  getTime(date) {
    date = new Date(date);
    let hours = date.getHours() + '';
    let minute = date.getMinutes() + '';
    if (hours.length === 1) hours = '0' + hours;
    if (minute.length === 1) minute = '0' + minute;
    return hours + ':' + minute;
  },
  switchPage(stockcode, peroid = 8192, id = -6) {
    return new Promise((resolve, reject) => {
      API.use({
        method: 'Quote.switchPage',
        data: {
          id: id,
          period: peroid,
          code: stockcode
        },
        success: data => {
          resolve(data);
        },
        error: (errorcode, errormsg) => {
          reject({
            message: errormsg
          });
        },
        notClient: () => {
          resolve();
        }
      });
    });
  },
  /**
   * 将数据加上单位，并保留几位有效数字
   */
  getUnitNumber(num, dig = 2, unit = 1, isint) {
    num = parseFloat(num);
    if (num === 0) {
      return '0';
    }
    if (isNaN(num)) {
      return '--';
    } else {
      if ((num > 9999 && num < 9999999) || (num < -9999 && num > -9999999)) {
        num = (num / 10000).toFixed(dig);
        unit = unit ? '万' : '';
      } else if (num >= 9999999 || num <= -9999999) {
        num = (num / 100000000).toFixed(dig);
        unit = unit ? '亿' : '';
      } else {
        unit = '';
        num = isint ? num : num.toFixed(dig);
      }
      return num + unit;
    }
  },
  formatPercent(v, types = 0, unit = '%', flag = '') {
    if (v === null || v === undefined) return '--';
    if (v === 0) {
      return '<span >0</span>';
    }

    let type = '',
      add = '';
    if (v > 0) {
      type = 'red';
      if (flag) {
        add = '+';
      }
    }
    if (v < 0) {
      type = 'green';
    }
    let result = '';
    switch (types) {
      case 0: //格式化成百分数
        result = this.getUnitNumber(v) + unit;
        break;
      case 1: //格式化成整数
        result = this.getUnitNumber(v, 2, 1, 1) + unit;
        break;
      case 2: //格式化成保留两位的小数
        result = this.getUnitNumber(v) + unit;
        break;
    }

    return v !== null && v !== undefined ? "<span class='" + type + "' >" + add + result + '</span>' : '--';
  },
  userInterval: function (callback, time) {
    return setInterval(() => {
      if (window.$onshow) {
        // console.log('执行')
        callback()
      } else {
        // console.log('切出，不执行')
      }
    }, time)
  }
};



// WEBPACK FOOTER //
// ./src/utils/util.js